import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'reactstrap';

class FeaturedResource extends React.Component {
  render() {
    const image =
      this.props.iconClass != null ? (
        <div className="circle-icon m-auto d-flex">
          <i className={`${this.props.iconClass} m-auto`} />
        </div>
      ) : (
        <img
          className="featured-image"
          src={this.props.imageUrl}
          loading="lazy"
          alt={this.props.title}
        />
      );
    return (
      <div className="featured-container">
        <div className="card-container m-0 p-0 featured">
          <Row className="p-0 m-0 featured-resource-content">
            <Col xs={4} md={2} lg={3} xl={4} className="p-0  d-flex">
              {image}
            </Col>
            <Col xs={8} md={10} lg={9} xl={8} className="pt-3">
              <p className="resource-title">{this.props.title}</p>
              <p className="resource-description">{this.props.description}</p>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}
FeaturedResource.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  iconClass: PropTypes.string,
  imageUrl: PropTypes.string,
};
export default FeaturedResource;
